/**
 * @desc Returns the pie chart options
 * 
 * @param {String} title Title of the pie chart
 * @param {String} xAxis Label for the xAxis
 * @param {String} position Position of the key
 * @returns 
 */
export function retPieOptions(title, xAxis, position = "bottom") {
    return {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            tooltip: {
                callbacks: {
                    label: function (item) {
                        var data = item.dataset.data,
                            label = item.label,
                            currentValue = item.raw,
                            total = 0

                        for (var i = 0; i < data.length; i++) {
                            total += Number(data[i])
                        }
                        var percentage = parseFloat((currentValue / total * 100).toFixed(2))

                        return label + ": " + currentValue + ' (' + percentage + '%)';
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 20
                }
            },

            legend: {
                title: {
                    display: true,
                    text: xAxis,
                },
                labels: {
                    font: {
                        size: 15
                    },

                    usePointStyle: true,
                    filter: (legendItem, data) => data.datasets[0].data[legendItem.index] != 0
                },
                position: position
            }
        }
    }
}


/**
 * @desc Return Line chart options
 * 
 * @param {String} title Title of the line chart
 * @param {String} indexAxis Orientation of line chart
 * @param {String} xAxis Label for the x axis
 * @param {String} yAxis Label for the y axis
 * @param {String} label
 * @param {String} position Position of the key
 * @returns 
 */
export function retLineOptions(title, indexAxis, xAxis, yAxis, label, position = "bottom") {
    return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: indexAxis,

        scale: {
            ticks: {
                precision: 0
            }
        },

        scales: {
            x: {
                display: true,
                title: {
                    display: true,
                    text: xAxis
                },
            },
            y: {
                display: true,
                title: {
                    display: true,
                    text: yAxis
                }
            },
        },

        plugins: {
            tooltip: {
                callbacks: {
                    label: function (item) {
                        var data = item.dataset.data,
                            label = item.label,
                            currentValue = item.raw,
                            total = 0

                        for (var i = 0; i < data.length; i++) {
                            total += data[i]
                        }
                        var percentage = parseFloat((currentValue / total * 100).toFixed(2))

                        return label + ": " + currentValue + ' (' + percentage + '%)';
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 20
                },
            },
            legend: {
                text: label,
                labels: {
                    font: {
                        size: 14,
                    },
                    usePointStyle: true,
                },
                position: position
            }
        }
    }
}


/**
 * @desc Return Bar chart options
 * 
 * @param {String} title Title of the Bar chart
 * @param {String} indexAxis Orientation of line chart
 * @param {String} xAxis Label for the x axis
 * @param {String} yAxis Label for the y axis
 * @returns 
 */
export function retBarOptionsIssues({legend, title, indexAxis, xAxis, yAxis, barThickness=15, onClickHandler}) {
    let barOptions = retBarOptions(legend, title, indexAxis, xAxis, yAxis, barThickness);
    return {
        ...barOptions,
        onClick(event, elements, chart) {
            onClickHandler(event, elements, chart);
        }
    }
}


/**
 * @desc Return Bar chart options
 * 
 * @param {String} title Title of the Bar chart
 * @param {String} indexAxis Orientation of line chart
 * @param {String} xAxis Label for the x axis
 * @param {String} yAxis Label for the y axis
 * @returns 
 */
export function retBarOptions(legend, title, indexAxis, xAxis, yAxis, barThickness=15) {
    return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: indexAxis,
        barThickness: barThickness,

        scale: {
            precision: 0
        },

        scales: {
            x: {
                stacked: true,
                display: true,
                title: {
                    display: true,
                    text: xAxis
                }
            },
            y: {
                stacked: true,
                display: true,
                title: {
                    display: true,
                    text: yAxis
                },
                grid: {
                    lineWidth: 1,
                }
            },
        },

        plugins: {
            tooltip: {
                callbacks: {
                    label: function (item) {
                        var data = item.dataset.data,
                            label = item.dataset.label,
                            currentValue = item.raw,
                            total = 0

                        for (var i = 0; i < data.length; i++) {
                            total += data[i]
                        }
                        var percentage = parseFloat((currentValue / total * 100).toFixed(2))

                        if (label) {
                            label = `${label} :  ${currentValue}`
                            return label ?? '' + ": " + currentValue + ' (' + percentage + '%)';
                        } 
                        
                        return currentValue + ' (' + percentage + '%)';
                    }
                }
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 20
                },
            },
            legend: {
                display: legend,
                position: 'right',
            }
        }
    }
}